module.exports = {
  "dof-col": {
    "flex": 1,
    "flexDirection": "column",
    "position": "relative",
    "overflow": "hidden"
  },
  "borderRight": {
    "position": "absolute",
    "width": "2",
    "backgroundColor": "#f2f2f2",
    "right": 0
  },
  "borderBottom": {
    "position": "absolute",
    "height": "2",
    "backgroundColor": "#f2f2f2",
    "bottom": 0
  },
  "delta": {
    "width": "26",
    "height": "26",
    "backgroundColor": "#f2f2f2",
    "position": "absolute",
    "right": "-13",
    "bottom": "-13",
    "transform": "rotate(45deg)"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-7b6ffb66!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-numcard-col/index.vue
// module id = 522
// module chunks = 0 1